import { render, staticRenderFns } from "./DDTab.vue?vue&type=template&id=1cb3d381&scoped=true&"
import script from "./DDTab.vue?vue&type=script&lang=js&"
export * from "./DDTab.vue?vue&type=script&lang=js&"
import style0 from "./DDTab.vue?vue&type=style&index=0&id=1cb3d381&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3d381",
  null
  
)

export default component.exports